import PropTypes from 'prop-types';

export const OrderItemType = PropTypes.shape({
  id: PropTypes.number,
  posOrderId: PropTypes.number,
  quantity: PropTypes.number,
  inventoryItemId: PropTypes.number,
  inventoryLocationId: PropTypes.number,
  inventoryLocationZoneId: PropTypes.number,
  meta: PropTypes.shape({
    item: PropTypes.shape({}),
    location: PropTypes.shape({}),
    zone: PropTypes.shape({})
  }),
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string
});

export const OrderType = PropTypes.shape({
  id: PropTypes.number,
  userId: PropTypes.number,
  visitId: PropTypes.number,
  clientId: PropTypes.number,
  visitTrackId: PropTypes.number,
  trackingMethodId: PropTypes.number,
  outreachId: PropTypes.number,
  locationId: PropTypes.number,
  status: PropTypes.number,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  canceledAt: PropTypes.string,
  trackingMethod: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  items: PropTypes.arrayOf(OrderItemType)
});
